import { render, staticRenderFns } from "./il-language-selection.vue?vue&type=template&id=0ab877ce"
import script from "./il-language-selection.vue?vue&type=script&lang=ts"
export * from "./il-language-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports